<template>
  <Loader v-if="isLoading"></Loader>
  <Alert
    v-if="errorMsgs.length"
    :messages="errorMsgs"
    :dismissible="false"></Alert>

  <div class="b-ticket__el-holding">
    <div class="b-ticket__deal-holder">
      <img width="50" :src="item.icon" :alt="item.name" />
      <div>
        <div class="b-ticket__title">{{ item.name }}</div>
        <div class="b-ticket__price">
          {{ lib.roundToDigits(item.ticketPrice) }} €
        </div>
      </div>
    </div>
    <div class="b-ticket__counter-wrapper">
      <div>
        <button
          v-if="showRemoveTicket"
          type="button"
          class="btn-icon btn--minus-icon"
          @click="onClickRemoveTicket"></button>
      </div>

      <div class="b-ticket__counter">{{ count }}</div>

      <div>
        <button
          type="button"
          class="btn-icon btn-plus-icon"
          :disabled="isDisabledAddTickets"
          @click="onClickAddTickets"></button>
      </div>
    </div>
  </div>
</template>

<script setup>
import axios from 'axios'
import { computed, getCurrentInstance, nextTick, ref } from 'vue'
import Loader from './../../../components/Shared/Loader.vue'
import Alert from './../../../components/Shared/Alert.vue'
import * as lib from './../../../../lib/lib'
import { useBookingStore } from '../../../store/BookingStore'
import { last } from 'underscore'
const store = useBookingStore()
const emit = defineEmits(['add-tickets'])
const isLoading = ref(false)
const errorMsgs = ref([])
const { dictionary, configuration } =
  getCurrentInstance().appContext.config.globalProperties

// props
const props = defineProps({
  item: {
    default() {
      return {}
    },
    type: Object,
    required: true,
  },
  index: {
    default() {
      return 0
    },
    type: Number,
    required: true,
  },
})

const count = computed(() => {
  const { selectedTickets } = store.bookingProgress
  const entry = selectedTickets[props.item.id]
  return entry ? entry.count : 0
})

const showRemoveTicket = computed(() => {
  const { selectedTickets } = store.bookingProgress
  return selectedTickets[props.item.id]
})

const isDisabledAddTickets = computed(() => {
  const sum = store.getSeatsCount + props.item.seatsCount
  return sum > configuration.maximumTickets
})

const onClickAddTickets = () => {
  emit('add-tickets', props.item, props.index)
}

const onClickRemoveTicket = async () => {
  isLoading.value = true

  const { id, offerId } = props.item
  // get last inserted code
  const codes = store.getSelectedTicket(id)?.codes
  const code = codes.length ? last(codes) : null
  const postData = {
    code,
    offerId,
    userSessionId: store.bookingProgress.usersessionId,
  }

  const endpoint = configuration.endpointCD4URemoveTicket
  try {
    const resp = await axios.post(endpoint, postData, lib.axiosConfig)
    const { data } = resp

    if (data.hasError) {
      return handleError(data.errorMessages)
    }

    store.removeTicket({
      ticketId: props.item.id,
    })

    handleSuccess()
  } catch (errors) {
    handleError([dictionary.defaultErrorMessage])
    console.error(errors)
  }
}

const handleSuccess = () => {
  isLoading.value = false
  errorMsgs.value = []
}

const handleError = async (messages) => {
  errorMsgs.value = messages
  isLoading.value = false

  await nextTick()
  lib.scrollToError()
}
</script>
